import { render } from "./TheSimpleHeader.vue?vue&type=template&id=515866a0&scoped=true&ts=true"
import script from "./TheSimpleHeader.vue?vue&type=script&lang=ts"
export * from "./TheSimpleHeader.vue?vue&type=script&lang=ts"

import "./TheSimpleHeader.vue?vue&type=style&index=0&id=515866a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515866a0"]])

export default __exports__